module.exports = __webpack_public_path__ + "img/wishlist.e90804d1.png";